const firebaseConfig = {
    apiKey: "AIzaSyDNWT55rNtYo9RkN9AdrxpF5ev4FuolZ7I",
    authDomain: "volunteer-network-97cd7.firebaseapp.com",
    databaseURL: "https://volunteer-network-97cd7.firebaseio.com",
    projectId: "volunteer-network-97cd7",
    storageBucket: "volunteer-network-97cd7.appspot.com",
    messagingSenderId: "1002816879017",
    appId: "1:1002816879017:web:3e02b959246dcd972bacb8"
  };

  export default firebaseConfig;